module.exports = __webpack_public_path__ + "static/uni_cambridge-757625f939bc862daefb38f71c5eb573.png";